import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.css'

const ChechBox = (props) => {

  let name = props.name || Array(5).fill().map(n=>(Math.random()*36|0).toString(36)).join('')

  return (
    <div className={styles.checkbox}>
      <input {...props} type="checkbox" id={name} />
      <label htmlFor={name}></label>
    </div>
  )
}

ChechBox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func
}

export default ChechBox
